import { NgModule } from '@angular/core';
import { CORE_COMMON_PROVIDERS } from './core-common.providers';

@NgModule({
  declarations: [],
  exports: [],
  imports: [],
  providers: [CORE_COMMON_PROVIDERS]
})
export class CmxCoreCommonModule {}
